import React from 'react';
import { Link } from '@inertiajs/react';
import { ChevronRight, Home } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
    label: string;
    href?: string;
}

interface BreadcrumbsProps {
    items: BreadcrumbItem[];
    className?: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, className = '' }) => {
    const { t } = useTranslation();
    
    return (
        <nav className={`flex items-center space-x-2 text-sm ${className}`} aria-label="Breadcrumb">
            <Link href="/" className="flex items-center text-gray-500 hover:text-gray-700">
                <Home size={16} className="mr-1" />
                {t('home.home')}
            </Link>
            
            {items.map((item, index) => (
                <React.Fragment key={index}>
                    <ChevronRight size={16} className="text-gray-400" />
                    {item.href ? (
                        <Link 
                            href={item.href} 
                            className="text-gray-500 hover:text-gray-700 truncate"
                        >
                            {item.label}
                        </Link>
                    ) : (
                        <span className="text-gray-900 font-medium truncate">
                            {item.label}
                        </span>
                    )}
                </React.Fragment>
            ))}
        </nav>
    );
};

export default Breadcrumbs;